import { c as createCommonjsModule } from './common/_commonjsHelpers-8c19dec8.js';

var shallowEqualObject = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var hasOwn = Object.prototype.hasOwnProperty;
// Object.is ponyfill
exports.is = function (x, y) {
    if (x === y) {
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    else {
        return x !== x && y !== y;
    }
};
/**
 * Return true, if `objectA` is shallow equal to `objectB`.
 * Pass Custom equality function to `customEqual`.
 * Default equality is `Object.is`
 *
 * Options:
 *
 * - `customEqual`: function should return true if the `a` value is equal to `b` value.
 * - `debug`: enable debug info to console log. This log will be disable in production build
 */
exports.shallowEqual = function (objectA, objectB, options) {
    if (objectA === objectB) {
        return true;
    }
    if (typeof objectA !== "object" || objectA === null) {
        return false;
    }
    if (typeof objectB !== "object" || objectB === null) {
        return false;
    }
    var keysA = Object.keys(objectA);
    var keysB = Object.keys(objectB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    var isEqual = options && typeof options.customEqual === "function" ? options.customEqual : exports.is;
    for (var i = 0; i < keysA.length; i++) {
        var key = keysA[i];
        if (!hasOwn.call(objectB, key) || !isEqual(objectA[key], objectB[key])) {
            return false;
        }
    }
    return true;
};

});

var shallowEqual = shallowEqualObject.shallowEqual;
export { shallowEqual };
